<template>
  <div class="products">
    <el-dialog title="编辑产品" :visible.sync="dialogVisible" :modal="modal" :before-close="closeDialog" width="700px">
      <div class="content">
        <div class="select">
          <div>产品数：{{idArr.length}}</div>
          <el-button @click="addProducts">添加产品</el-button>          
        </div>
        <div class="table">
          <el-table
            ref="table"
            :data="selectProducts" 
            border
            height="360"
            @click.native="tableClick">
            <el-table-column
              width="40">
              <template slot-scope="scope">
                <i 
                  class="el-icon-circle-close delete"
                  data-type="del"
                  :data-index="scope.$index"
                ></i>
              </template>
            </el-table-column>
            <el-table-column
              v-for="(name, attr) in tableHead[moduleName]"
              :show-overflow-tooltip="true"
              :prop="attr"
              :label="name"
              :key="attr"
              :width="getWidth(attr)"
            >
            <template slot-scope="scope">
              <template v-if="attr === 'name'">
                <p class="productNo">{{scope.row.productNo}}</p>
                <el-tooltip effect="dark" :content="scope.row.name" placement="top-start">
                  <p class="name"><span class="gift" v-if="scope.row.productPrice === 0 || scope.row.productPrice === '0.00'">[赠品]</span>{{scope.row.name}}</p>
                </el-tooltip>
              </template>
              <div v-else-if="attr === 'discount'">
                <el-input size="small" v-model.number="scope.row.discount" @change="discountChange(scope.$index, scope.row)"></el-input>
              </div>              
              <div v-else-if="attr === 'productPrice'">
                <el-input size="small" v-model.number="scope.row.productPrice" @change="priceChange(scope.$index, scope.row)"></el-input>
              </div>
              <div v-else-if="attr === 'num'">
                <el-input size="small" v-model.number="scope.row.num" :min="0" @change="numChange(scope.$index, scope.row)"></el-input>
              </div>
              <div v-else-if="attr === 'memo'">
                <el-input type="textarea" :autosize="{minRows: 1, maxRows: 3}" v-model="scope.row.memo"></el-input>
              </div>
              <div v-else-if="attr === 'specification'">
                {{scope.row.specification || '--'}}
              </div>
              <div v-else-if="attr === 'totalPrice'">
                {{Number(Number(scope.row.totalPrice).toFixed(6))}}
              </div>
              <div v-else>
                {{scope.row[attr] || (scope.row[attr] === 0 ? 0 : '--')}}
              </div>
              </template>
            </el-table-column>          
          </el-table>
          <div class="statistics" v-if="['workOrder'].indexOf(moduleName) === -1">
            <div class="totalPrice">产品合计(元)：{{totalPrice}}</div>
            <div class="otherPrice" v-if="surchargeArr && surchargeArr.length">
              <span class="price" :class="{'discounts': item.surchargeType === 2}" v-for="(item, index) in surchargeArr">
                <label>{{item.surchargeName}}(元)：{{item.surchargeType===2?'-':'+'}}</label>
                <el-input size="small" v-model.number="item.amount" :ref="'surcharge'+index" @change="changePrice()" @blur="changePrice(index, 'blur', item.amount)"></el-input>
              </span>                           
            </div>                                                                                                                         
          </div>
        </div>
      </div>
      <!-- 兼容工单 -->
      <div slot="footer" class="dialog-footer" v-if="['workOrder'].indexOf(moduleName) > -1">
        <div  style="margin: 0 auto;">
          <el-button type="primary" class="editBtn" @click="handleSubmit">保存</el-button>
          <el-button @click="closeDialog">取 消</el-button>          
        </div>
      </div>
      <div slot="footer" class="dialog-footer" v-else>
        <span>{{title}}金额：{{contractPrice}}</span>
        <div>
          <el-button type="primary" class="editBtn" @click="handleSubmit">保存</el-button>
          <el-button @click="closeDialog">取 消</el-button>          
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  // import * as api from 'src/api'
  // import { mapGetters, mapActions } from 'vuex'
  import { Message } from 'element-ui'
  import { mapActions } from 'vuex'

  export default {
    created () {
      this.dialogVisible = true
      this.changePrice()
    },
    props: ['moduleName', 'surchargeList', 'modal', 'productList', 'selectProducts', 'decimalPrecisionMap'],
    data () {
      return {
        dialogVisible: false,
        options: [], // 产品分类选的值
        contactSearch: '', // 搜索的值
        tableHead: {
          contractApi: {
            name: '产品名称',
            specification: '规格',
            price: '单价 (元)',
            discount: '折扣 (%)',
            productPrice: '售价 (元)',
            num: '数量',
            memo: '备注',
            unit: '单位',
            totalPrice: '小计 (元)'
          },
          opportunityApi: {
            name: '产品名称',
            specification: '规格',
            price: '单价 (元)',
            discount: '折扣 (%)',
            productPrice: '售价 (元)',
            num: '数量',
            unit: '单位',
            totalPrice: '小计 (元)'
          },
          workOrder: {
            name: '产品名称',
            specification: '规格',
            price: '单价 (元)',
            num: '数量',
            unit: '单位'
          }
        },
        contractPrice: 0,
        title: this.moduleName === 'contractApi' ? '合同' : '机会'
      }
    },
    computed: {
      idArr () {
        return this.selectProducts.map(item => item.id) || this.productList.map(item => item.productId)
      },
      totalPrice () {
        let price = 0
        this.selectProducts.forEach(item => {
          // price += Number(item.totalPrice)
          let numTotal = Number(item.totalPrice)
          price = utils.plus(price, numTotal)
        })
        return Number(parseFloat(price).toFixed(6))
      },
      surchargeArr () {
        if (this.surchargeList && this.surchargeList.length) {
          for (let i = 0; i < this.surchargeList.length; i++) {
            this.surchargeList[i].amount = this.surchargeList[i].amount ? (this.surchargeList[i].amount > 0 ? this.surchargeList[i].amount : -this.surchargeList[i].amount) : 0
          }
          return this.surchargeList
        }
        return []
      }
    },
    methods: {
      ...mapActions([
        'computedTotal',
        'increaseSelect',
        'decreaseSelect'
      ]),

      // 列宽
      getWidth (attr) {
        if (['num', 'price', 'discount', 'productPrice'].indexOf(attr) > -1) {
          return 100
        } else if (['memo'].indexOf(attr) > -1) {
          return 200
        }
      },

      // 提示限制了几位小数
      tipsFun (decimalPrecision, row) {
        let value = row.toString()
        if (value.indexOf('.') !== -1) {
          var precisionLen = value.split('.')[1].length // 获取input输入小数位的长度
          if (precisionLen > decimalPrecision) {
            // 如果小数位超出就提示
            let messageText = '限制了' + decimalPrecision + '位小数'
            Message({
              message: messageText,
              type: 'warning'
            })
          }
        }
      },

      changePrice (index, type, value) {
        if (type === 'blur') {
          let amount = Number(Number(this.surchargeArr[index].amount).toFixed(this.decimalPrecisionMap['price']))
          this.surchargeArr[index].amount = amount > 0 ? amount : -amount || 0
          if (this.$refs['surcharge' + index]) {
            this.$refs['surcharge' + index][0].currentValue = this.surchargeArr[index].amount
          }
          // 提示
          this.tipsFun(this.decimalPrecisionMap['price'], value)
        }
        let price = parseFloat(this.totalPrice)
        if (this.surchargeArr && this.surchargeArr.length) {
          for (let i = 0; i < this.surchargeArr.length; i++) {
            if (this.surchargeArr[i].surchargeType === 2) {
              // 减法精度
              let subPrice = parseFloat(this.surchargeArr[i].amount) || 0
              price = utils.subtract(price, subPrice)
              // price = price - (parseFloat(this.surchargeArr[i].amount) || 0)
            } else {
              // 加法精度
              let plusPrice = parseFloat(this.surchargeArr[i].amount) || 0
              price = utils.plus(price, plusPrice)
              // price = price + (parseFloat(this.surchargeArr[i].amount) || 0)
            }
          }
        }
        this.contractPrice = Number(parseFloat(price).toFixed(6))
      },
      addProducts () {
        this.$emit('selectId', this.selectProducts)
        this.$emit('showProduct', 'add')
        this.dialogVisible = false
      },
      // 当num字段的值变化时，触发selectProducts更新
      numChange (index, row) {
        this.$nextTick(() => {
          if (index > -1) {
            // 提示
            this.tipsFun(this.decimalPrecisionMap['stock'], Number(row.num))
            // 允许小数点输入
            let num = Number(Number(row.num).toFixed(this.decimalPrecisionMap['stock']))
            // this.selectProducts[index].num = parseFloat(row.num) > 0 ? parseFloat(row.num) : -parseFloat(row.num) || 1
            this.selectProducts[index].num = num > 0 ? num : -num || 1
            this.selectProducts[index].totalPrice = Number((num * row.productPrice || 0).toFixed(6))
            this.changePrice()
          }
        })
      },
      // 当productPrice字段的值变化时，触发selectProducts更新
      priceChange (index, row) {
        this.$nextTick(() => {
          if (index > -1) {
            // 提示
            this.tipsFun(this.decimalPrecisionMap['price'], Number(row.productPrice))
            // 允许小数点输入
            let productPrice = Number(Number(row.productPrice).toFixed(this.decimalPrecisionMap['price']))
            this.selectProducts[index].productPrice = productPrice > 0 ? productPrice : -productPrice || 0
            if (row.price) {
              this.selectProducts[index].discount = Math.abs(Number(((productPrice || 0) * 100 / row.price).toFixed(2)))
            } else {
              this.selectProducts[index].discount = 100
            }
            this.selectProducts[index].totalPrice = Number((row.num * productPrice || 0).toFixed(6))
            this.changePrice()
          }
        })
      },
      // 当discount字段的值变化时，触发selectProducts更新
      discountChange (index, row) {
        this.$nextTick(() => {
          if (index > -1) {
            this.selectProducts[index].discount = parseFloat(row.discount) > 0 ? Number(parseFloat(row.discount).toFixed(2)) : -Number(parseFloat(row.discount).toFixed(2)) || 100
            this.selectProducts[index].productPrice = Number((row.price * parseFloat(row.discount) / 100 || 0).toFixed(this.decimalPrecisionMap['price']))
            this.selectProducts[index].totalPrice = Number((row.num * row.productPrice || 0).toFixed(2))
            this.changePrice()
          }
        })
      },
      // 提交数据
      handleSubmit () {
        if (this.moduleName === 'contractApi') {
          // 校验合同产品备注字符不超过200
          let count = 0
          let name = ''
          this.selectProducts.map((item) => {
            if (item.memo && item.memo.length > 200) {
              name = item.name
              count++
            }
          })
          if (count) {
            Message({
              type: 'error',
              message: '产品备注的长度不能超过200个字符:' + name
            })
            return false
          }
          this.$emit('emitProductsData', this.selectProducts, this.contractPrice, this.surchargeList)
        } else if (this.moduleName === 'opportunityApi') {
          this.$emit('emitProductsData', this.selectProducts, this.contractPrice)
        } else if (this.moduleName === 'workOrder') {
          this.$emit('emitProductsData', this.selectProducts)
        }
        this.dialogVisible === false
      },
      // 监听table点击事件
      tableClick (event) {
        // 获取目标元素或目标父元素的data属性集合
        let data = event.target.dataset
        // 如果存在type属性，则是一个可执行的事件
        if (data.type && data.type === 'del') {
          let index = data.index
          this.selectProducts.splice(index, 1)
          this.changePrice()
        }
      },

      closeDialog () {
        this.$emit('close')
      }
    },
    components: {
    },
    filters: {
      // 数组转字符串
      arrToStr (arr) {
        let str = ''
        if (arr instanceof Array && arr.length > 0) {
          str = arr[0]
          for (let i = 1; i < arr.length; i++) {
            str += ',' + arr[i]
          }
        } else {
          if (typeof arr === 'string') {
            arr = JSON.parse(arr) || []
            if (arr.length > 0) {
              str = arr[0]
              for (let i = 1; i < arr.length; i++) {
                str += ',' + arr[i]
              }
            }
          }
        }
        return str
      }
    },
    watch: {
      // 详情页监听的窗口关闭事件
      dialogVisible () {
        if (this.dialogVisible === false) {
          this.$emit('closeForDetail')
        }
      },
      selectProducts: {
        handler () {
          console.log(1, this.selectProducts)
        },
        deep: true
      }
    }
  }
</script>
<style type="text/css" lang="less">
  .products {
    .discounts {
      .el-input__inner {
        color:#ff6161;
      }
    }    
    .el-dialog__body {
      padding: 0;
    }
  }
</style>
<style type="text/css" lang="less" scoped>
  .products {
    .content {
      padding: 0 25px 27px 25px;
      .productNo {
        font-size: 12px;
        color: #929292;
        margin-bottom: -5px;
        line-height: 30px;
      }
      .gift {
        color: #ff6161;
      }
      .cell {
        .name {
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 13px;
          color: #666666;
        }
      }
      .select {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 15px 0;      
      }
      .delete {
        font-size: 16px;
        cursor: pointer;
        color: #ff6161;
      }
      .statistics {
        border: 1px solid #e5e8f2;
        border-top: 0;
        .totalPrice {
          height: 28px;
          padding-left: 15px;
          border-bottom: 1px solid #e5e8f2;
          line-height: 28px;
        }
        .otherPrice {
          padding-left: 15px;
          display: inline-block;
          max-height: 100px;
          overflow: auto;
          .price {
            margin-right: 48px;
            margin-right: 48px;
            display: inline-block;
            margin: 5px 48px 5px 0;
            .el-input {
              width: 60px;
            }
          }
          .discounts {
            color:#ff6161;
          }
        }
      }
    }
    .dialog-footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .editBtn {
        background: #ff7c35;
        border-color: #ff7c35;
      }
    }
    /deep/.el-table__body-wrapper {
      overflow-y: auto;
    }
  }
</style>


// WEBPACK FOOTER //
// products.vue?3bbe4be9